import React, { Fragment } from 'react';
import { withStyles, makeStyles, createStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox, { CheckboxProps } from '@material-ui/core/Checkbox';

const GreenCheckbox = withStyles({
	root: {
		fontSize: '12px',
		color: green[400],
		'&$checked': {
			color: green[600],
		},
	},
	checked: {},
})((props: CheckboxProps) => <Checkbox color="default" {...props} />);

export const useStyles = makeStyles(() =>
	createStyles({
		subText: {
			color: '#FF7552',
			fontSize: '12px',
		},
		textConfig: {
			fontWeight: 'lighter',
		},
	}),
);

interface CustomCheckBoxTypes {
	mainText?: string;
	subText?: string;
	handleChangeCheckbox?: any;
	checked?: any;
}
const CustomCheckBox = ({ mainText, subText, checked, handleChangeCheckbox }: CustomCheckBoxTypes) => {
	const classes = useStyles();
	return (
		<Fragment>
			<FormGroup row >
				<FormControlLabel
					control={<GreenCheckbox checked={checked} onChange={handleChangeCheckbox} name="checked" />}
					label={
						<small className={classes.textConfig}>
							<span
								style={{
									fontSize: '12px',
								}}
							>
								{mainText}
							</span>{' '}
							<span className={classes.subText}> <a href="http://www.fledglingsflight.com/terms-of-service" target="_blank" rel="noreferrer">{subText}</a>  </span>
						</small>
					}
				/>
			</FormGroup>
		</Fragment>
	);
};

export default CustomCheckBox;
